// extracted by mini-css-extract-plugin
export default {"footerWrapper":"footer_footerWrapper__g1S1U","imgCard":"footer_imgCard__dKBHV","img":"footer_img__OKL5R","songName":"footer_songName__43U7L","albumName":"footer_albumName__cfQiI"};